export const DAILY = 1
export const ONETIME = 2

export const servicePricingDynamicOptions = [
  { value: DAILY, label: 'Daily' },
  { value: ONETIME, label: 'One time' }
]
